(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class FooterMenu extends DetailsDisclosure {
      constructor() {
        super();
        this.reset(false);
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        const isConfirmNewsletter = !isLargeScreen &&
          (window.location.hash === "#footer-signup_form" && this.querySelector('#footer-signup_form') !== null);

        this.disclosure.open = isLargeScreen || isConfirmNewsletter;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }
    }

    customElements.define('footer-menu', FooterMenu);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["modaz-cart-progress"] && !Shopify.designMode) return;
  try {
    
(function(){function money(c,currency,locale){try{return new Intl.NumberFormat(locale||'en-GB',{style:'currency',currency:currency||'GBP'}).format(c/100)}catch(e){return '£'+(c/100).toFixed(2)}}function render(cart){document.querySelectorAll('[data-mz-cart-progress]').forEach(function(root){var threshold=parseInt(root.dataset.shipThreshold,10)||4000,group=parseInt(root.dataset.teeGroup,10)||4,currency=root.dataset.currency||'GBP',locale=root.dataset.locale||'en-GB',qty=Number(cart.item_count||0),total=Number(cart.total_price||0);root.classList.toggle('is-hidden',qty===0);if(qty===0)return;var sl=root.querySelector('[data-mz-ship-label]'),sb=root.querySelector('[data-mz-ship-bar]'),remaining=Math.max(0,threshold-total);if(sl)sl.innerHTML=total>=threshold?"You've unlocked <strong>free shipping</strong>":"You're <strong>"+money(remaining,currency,locale)+"</strong> away from <strong>free shipping</strong>";if(sb)sb.style.setProperty('--mz-progress',Math.min(1,total/threshold));var tl=root.querySelector('[data-mz-tee-label]'),tb=root.querySelector('[data-mz-tee-bar]'),mod=qty%group,into=mod===0&&qty>0?group:mod,msg;if(mod===1)msg='Add <strong>2 more tees</strong> to unlock your <strong>FREE 4th tee</strong>';else if(mod===2)msg='Just <strong>1 more tee</strong> to unlock your <strong>FREE 4th tee</strong>';else if(mod===3)msg='<strong>Your 4th tee is FREE — add it now!</strong>';else msg='<strong>FREE 4th tee unlocked ✓</strong>';if(tl)tl.innerHTML=msg;if(tb)tb.style.setProperty('--mz-progress',into/group)})}function refresh(){fetch('/cart.js',{headers:{Accept:'application/json'}}).then(function(r){return r.json()}).then(render).catch(function(){})}document.addEventListener('on:line-item:change',refresh);document.addEventListener('cart:updated',refresh);document.addEventListener('cart:change',refresh);document.addEventListener('cart:refresh',refresh);document.addEventListener('DOMContentLoaded',refresh)})();

  } catch(e) { console.error(e); }
})();
})();
